export default {
    MANAGE_VERSION_UPDATE_REQUEST: 'APP/MANAGE_VERSION/MANAGE_VERSION_UPDATE_REQUEST',
    MANAGE_VERSION_UPDATE_SUCCESS: 'APP/MANAGE_VERSION/MANAGE_VERSION_UPDATE_SUCCESS',
    MANAGE_VERSION_UPDATE_ERROR: 'APP/MANAGE_VERSION/MANAGE_VERSION_UPDATE_ERROR',
  };